import React from "react";
import "./services.css";
import s1 from "../Assets/s1.png";
import s2 from "../Assets/s2.png";
import s3 from "../Assets/s3.png";
import s4 from "../Assets/s4.png";
import s5 from "../Assets/s5.png";
import s6 from "../Assets/s6.png";
import s7 from "../Assets/s7.png";
import sc2 from "../Assets/sc2.png"
import sccaregiver from "../Assets/sccaregiver.png"
import sc5 from "../Assets/sc5.png"
import sc6 from "../Assets/sc6.png"
import sc8 from "../Assets/sc8.png"
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { MdOutlineArrowOutward } from "react-icons/md";
import { Link } from "react-router-dom";
const services = [
  {
    title: "Home Nurse",
    desc: "From post-surgical care and chronic illness management to wound care, injections, and vital monitoring—our trained nurses...",
    img: s1,
    route: "home-nurse"
  },
  {
    title: "Baby Care",
    desc: `Our baby care services are designed to
make the early days of parenthood easier
and more enjoyable for you, providing ...`,
    img: sc2,
    route: "baby-care"
  },
  {
    img: sccaregiver,
    title: "Care Giver",
    desc: `Whether it's assisting with daily activities,
  providing medical support, or simply
  offering a listening ear, our caregivers ...`,
    route: "care-giver"
  },
  {
    title: "Home ICU Setup",
    desc: "Our Home ICU service includes advanced equipment, 24/7 critical care nurses, and doctor supervision, ideal for post-ICU...",
    img: s5,
    route: "home-icu-setup"

  },
  {
    img: sc5,
    title: "Doctor Consultation",
    desc: `Our team understands that every patient is
unique, which is why we tailor our 
consultations to your specific needs and ...`,
    route: "doctor-consultation"
  },
  {
    img: sc8,
    title: "Health Checks",
    desc: `Don't let your health take a back seat – take
control of your well-being today with our
home health checks. Book now and...`,
    route: "health-checks"
  },
  {
    img: sc6,
    title: "Physiotherapy",
    desc: `Say goodbye to the hassle of clinic visits
and hello to rehabilitation in the comfort
of your own home, where you...`,
    route: "physiotherapy"
  },
  {
    title: "Equipment Rental",
    desc: "Access medical equipment without the burden of ownership. From oxygen concentrators and wheelchairs...",
    img: s6,
    route: "medical-equipment"
  },
  {
    title: "Medicine Delivery",
    desc: "Our reliable medicine delivery service ensures timely access to genuine medications, saving you time and effort...",
    img: s7,
    route: "medicine-home-delivery"
  },
  {
    title: "Lab/Radiology",
    desc: "Bringing precision diagnostics to your doorstep. From blood tests to X-rays and other scans, our at-home lab and...",
    img: s4,
    route: "radiology"
  },

  {
    title: "At-Home Diagnostics",
    desc: "Our at-home diagnostic services offer fast, accurate sample collection and reporting right from your doorstep, ensuring...",
    img: s3,
    route: "diagnostics"
  },
];


function ServicesSnapshot() {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const visibleServices = showAll ? services : services.slice(0, 8);


  return (
    <div className="services-section" id="services">
      <h2>Services Snapshot</h2>
      <p>Services That Care as Much as You Do</p>
      <div className="services-grid">
        {visibleServices.map((item, index) => (
          <div
            className={`service-card ${index === 7 ? "view-all-card" : ""}`}
            key={index}
            onClick={() => navigate(`/${item.route}`)}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <img src={item.img} alt={item.title} />
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
            <Link to="/view-more">
              View More <MdOutlineArrowOutward size={18} />
            </Link>
 
            {!showAll && index === 7 && (
              <div
                className="view-all-overlay"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAll(true);
                }}
              >
                <span>View All <MdOutlineArrowOutward size={22} /> </span>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}

export default ServicesSnapshot;
